import React from "react";
import { AdminProducerAccountSummaryPreviewTemplate } from "themes/administration/producer/components";

function AdminProducerAccountSummaryPreview(props) {
    return <AdminProducerAccountSummaryPreviewTemplate {...props} />;
}

export default AdminProducerAccountSummaryPreview;
